import { Box, Card, CardActionArea, Typography } from "@mui/material";
// import ComputerIcon from "@mui/icons-material/Computer";
// import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import webView from '../../assets/webview.png'
import phone from '../../assets/mobile.png'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from "react";
import { getDocRoutes } from "../../services/api";

const AllDocs = () => {

  const [docRoutes, setDocRoutes] = useState()

  useEffect(() => {
    const fetchData = async () => {
      let resp = await getDocRoutes()
      setDocRoutes(resp?.data)
    }

    fetchData()
  }, [])

  const navigate = useNavigate()



  const options = docRoutes?.map(elm => ({
    label: elm.subject,
    icon: <img src={webView} />,
    url: `/documentations/v1/${elm.title}`
  }))

  return (
    <Box
      sx={{
        display: "flex",
        gap: 4,
        mt: 4,
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {options?.map((opt) => (
        <Card
          key={opt.label}
          sx={{
            width: 260,
            height: 200,
            borderRadius: 3,
            boxShadow: 3,
            transition: "0.3s",
            "&:hover": {
              boxShadow: 8,
              transform: "translateY(-4px)"
            }
          }}
        >
          <CardActionArea
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: 2,
              p: 3
            }}
            onClick={() => {
              navigate(opt.url)
            }}
          >
            {opt.icon}
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {opt.label}
            </Typography>
          </CardActionArea>
        </Card>
      ))}
    </Box>
  );
};

export default AllDocs;
